var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHide = function SvgIconHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    fillRule: "evenodd",
    d: "M17.12 8.598a.75.75 0 0 1 .283 1.022 9.9 9.9 0 0 1-2.267 2.708l.013.02 1.124 1.936a.75.75 0 0 1-1.296.754l-1.078-1.854c-.913.52-1.964.89-3.149 1.002v1.564a.75.75 0 0 1-1.5 0v-1.568a7.6 7.6 0 0 1-3.024-.997l-1.078 1.853a.75.75 0 0 1-1.296-.754l1.125-1.935.012-.021a11.7 11.7 0 0 1-2.368-2.67.75.75 0 0 1 1.259-.815C4.963 10.516 7.078 12.72 10 12.72c2.947 0 5.05-1.99 6.098-3.84a.75.75 0 0 1 1.022-.282",
    clipRule: "evenodd"
  })));
};
export default SvgIconHide;